<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Producto</mat-label>
        <mat-select formControlName="company_product_id">
          <mat-option value="">Todos</mat-option>
          @for (company_product of active_company_products; track company_product.company_product_id) {
            <mat-option [value]="company_product.company_product_id">{{ company_product.company_product_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Buscar</mat-label>
        <input matInput formControlName="search" placeholder="Título o contenido" />
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Título</th>
          <td mat-cell *matCellDef="let item">{{ item.title }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let item">{{ item.date | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="context">
          <th mat-header-cell *matHeaderCellDef>Contexto</th>
          <td mat-cell *matCellDef="let item">
            <div class="context-cell">
              <mat-chip [class]="item.meeting_type_chip_classes">{{ item.meeting_type_label }}</mat-chip>
              <span class="context-label">{{ item.context_label }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="resources">
          <th mat-header-cell *matHeaderCellDef>Recursos</th>
          <td mat-cell *matCellDef="let item">
            <div class="resource-icons">
              <mat-icon class="resource-indicator" [class.resource-available]="item.has_acta" matTooltip="Acta" aria-hidden="true"
                >description</mat-icon
              >
              <mat-icon
                class="resource-indicator"
                [class.resource-available]="item.server_processing_indicator.is_available"
                [class.resource-in-progress]="item.server_processing_indicator.is_in_progress"
                [class.resource-failed]="item.server_processing_indicator.is_failed"
                [matTooltip]="item.server_processing_indicator.tooltip"
                aria-hidden="true"
                >build</mat-icon
              >
              @if (item.youtube_upload_indicator.is_visible) {
                <mat-icon
                  class="resource-indicator"
                  [class.resource-available]="item.youtube_upload_indicator.is_available"
                  [class.resource-in-progress]="item.youtube_upload_indicator.is_in_progress"
                  [class.resource-failed]="item.youtube_upload_indicator.is_failed"
                  [matTooltip]="item.youtube_upload_indicator.tooltip"
                  aria-hidden="true"
                  >smart_display</mat-icon
                >
              }
              <mat-icon
                class="resource-indicator"
                [class.resource-available]="item.transcription_indicator.is_available"
                [class.resource-in-progress]="item.transcription_indicator.is_in_progress"
                [class.resource-failed]="item.transcription_indicator.is_failed"
                [matTooltip]="item.transcription_indicator.tooltip"
                aria-hidden="true"
                >subtitles</mat-icon
              >
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <button
              mat-icon-button
              type="button"
              matTooltip="Ver reunión"
              aria-label="Ver reunión"
              [disabled]="!item.acta_route"
              (click)="navigateToActa(item)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
